$(document).ready(function(){
    if (currentUrl.includes('inventories')) {
        if ($.fn.DataTable.isDataTable('#inventoryTable')) {
            $('#inventoryTable').DataTable().clear().destroy();
        }
        $('#inventoryTable').DataTable({
            responsive: true,
            processing: true,
            serverSide: true,
            pagingType: 'full_numbers',
            columns: [
                {
                    data: 'products',
                    name: 'Products',
                    orderable: true,
                    searchable: true
                },
                {
                    data: 'inventories',
                    name: 'Inventory',
                    orderable: true,
                    searchable: true
                },
            ],
            ajax: "/products/inventories",
        })
    }



    $(document).on('click', '.update-inventory', function() {
        var locationId = $(this).data('location-id');
        var productId = $(this).data('product-id');
        var quantity = $(this).prev('.quantity-input').val();

        //Send an AJAX request to update the inventory quantity
        $.ajax({
            url: '/products/inventories/update',
            type: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            },
            data: {
                location_id: locationId,
                product_id: productId,
                quantity: quantity
            },
            success: function(response) {
                var messageElement = $('<div class="alert alert-success fade show alert-dismissible mb-3" role="alert">' +
                    '<i class="fa fa-check-circle me-2"></i>' +
                    '<strong>Success!</strong> ' + response.message +
                    '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>' +
                    '</div>');

                // Prepend the message before the inventory list
                $('#alert-container').html(messageElement);
                $('#inventoryTable').DataTable().ajax.reload();

                // Auto-dismiss after 5 seconds
                setTimeout(function() {
                    messageElement.fadeOut();
                }, 5000);
            },
            error: function(error) {
                var messageElement = $('<div class="alert alert-danger fade show alert-dismissible mb-3" role="alert">' +
                    '<i class="fa fa-exclamation-triangle me-2"></i>' +
                    '<strong>Error!</strong> ' + (error.responseJSON?.message || 'Failed to update inventory') +
                    '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>' +
                    '</div>');

                $('#alert-container').html(messageElement);

                // Auto-dismiss after 5 seconds
                setTimeout(function() {
                    messageElement.fadeOut();
                }, 5000);
            }
        });
    });


    $(document).on('click', '.delete-inventory', function() {
        var locationId = $(this).data('location-id');
        var productId = $(this).data('product-id');

        swal({
            title: 'Are you sure?',
            text: 'Delete this Inventory!',
            icon: 'warning',
            buttons: {
                cancel: {
                    text: 'Cancel',
                    value: null,
                    visible: true,
                    className: 'btn btn-default',
                    closeModal: true,
                },
                confirm: {
                    text: 'Delete',
                    value: true,
                    visible: true,
                    className: 'btn btn-danger',
                    closeModal: true
                }
            }
        }).then((result) => {

            if (result) {
                $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    method: 'GET',
                    url: '/products/inventories/delete',
                    data: { product_id: productId, location_id:locationId},
                    success: function(response) {
                        if(response.success == true){
                            swal('Deleted!', response.message, 'success');
                        }else{
                            swal('Error!', 'Inventory Not Found', 'error');
                        }

                        $('#inventoryTable').DataTable().ajax.reload();
                    },
                    error: function(error) {
                        swal('Error!', 'An error occurred while removing the inventory.', 'error');
                    }
                });
            }
        });


    });

});

$(document).ready(function () {
    $(".default-select2").each(function () {
        $(this).select2({
            placeholder: 'Select a product',
            allowClear: true,
        });
    });
})

